'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _botUtils = require('../bot-utils');

var _responseUtils = require('../response-utils.js');

var _responseUtils2 = _interopRequireDefault(_responseUtils);

var _trafficManager = require('../traffic-manager.js');

var _trafficManager2 = _interopRequireDefault(_trafficManager);

var _avatarWrapper = require('../components/avatar-wrapper');

var _avatarWrapper2 = _interopRequireDefault(_avatarWrapper);

var _linkify = require('../components/linkify');

var _linkify2 = _interopRequireDefault(_linkify);

var _timestamp = require('../components/timestamp');

var _timestamp2 = _interopRequireDefault(_timestamp);

var _conversation = require('../store/selectors/conversation');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * BotActionText
 *
 * @Constructor
 * @class BotActionText
 * @public
 */
var BotActionText = function (_React$Component) {
  _inherits(BotActionText, _React$Component);

  function BotActionText(props) {
    _classCallCheck(this, BotActionText);

    var _this = _possibleConstructorReturn(this, (BotActionText.__proto__ || Object.getPrototypeOf(BotActionText)).call(this, props));

    var waitTimes = _this.props.escalate || _this.props.dialogFlow && _this.props.dialogFlow.escalate;
    _this.state = {
      text: _this.replaceTokens(_responseUtils2.default.getMessageText(_this.props, waitTimes), _this.props.userMessageText)
    };
    return _this;
  }

  /**
   * React method called after component mounted
   *
   * @private
   */


  _createClass(BotActionText, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      _trafficManager2.default.sendBotActionEvent('cx.help-bot.bot.text', this.props.intent ? this.props.intent : '', this.props.sessionId, this.state.text);
    }

    /**
     * @returns {string} Replaces instances of [queryText] in text with userMessageText
     *
     * @param {string} text The response message from dialog flow
     * @param {string} userMessageText The user message sent to dialog flow
     * @private
     */

  }, {
    key: 'replaceTokens',
    value: function replaceTokens(text, userMessageText) {
      var repRegex = /\[queryText\]/g;
      return text.replace(repRegex, '"' + userMessageText + '"');
    }

    /**
     * @returns {boolean} Checks conversation state to determine whether to render a timestamp
     *
     * @private
     */

  }, {
    key: 'shouldShowTimestamp',
    value: function shouldShowTimestamp() {
      var lastItem = this.props.conversation[this.props.index - 1];
      var lastItemIsBot = lastItem && ['image', 'search', 'text'].indexOf(lastItem.msgType) > -1;
      return this.props.timestamp && !lastItemIsBot;
    }

    /**
     * @returns {React.Element} render
     *
     * @private
     */

  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _avatarWrapper2.default,
        { hidden: !(0, _botUtils.shouldShowAvatar)(this.props.conversation, this.props.index) },
        this.shouldShowTimestamp() && _react2.default.createElement(_timestamp2.default, { msgType: this.props.msgType, timestamp: this.props.timestamp }),
        _react2.default.createElement(
          'div',
          { className: 'speech-bubble left' },
          _react2.default.createElement(_linkify2.default, _extends({ text: this.state.text }, this.props))
        )
      );
    }
  }]);

  return BotActionText;
}(_react2.default.Component);

/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 */


BotActionText.propTypes = {
  conversation: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
  dialogFlow: _propTypes2.default.object,
  escalate: _propTypes2.default.object,
  index: _propTypes2.default.number.isRequired,
  intent: _propTypes2.default.object,
  msg: _propTypes2.default.object.isRequired,
  msgType: _propTypes2.default.string.isRequired,
  sessionId: _propTypes2.default.string.isRequired,
  timestamp: _propTypes2.default.number,
  userMessageText: _propTypes2.default.string
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    conversation: (0, _conversation.conversationGet)(state),
    dialogFlow: state.app.dialogFlow
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(BotActionText);